import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV2 } from './api';

export interface IConsultationConclusionResponse {
  consultationId: string;
  userName: string;
  conclusion: string;
}

export interface IConsultationAbstractResponse {
  consultationId: string;
  userName: string;
  abstract: string;
}

export interface IConsultationHomeworkResponse {
  consultationId: string;
  userName: string;
  homework: string;
}

export interface IConsultationMetaphorResponse {
  consultationId: string;
  userName: string;
  metaphor: string;
}

export interface IConsultationMacTechniqueResponse {
  consultationId: string;
  userName: string;
  mac_technique?: string;
  macTechnique?: string;
}

export interface IConsultationTherapyPlanResponse {
  consultationId: string;
  userName: string;
  therapy_plan?: string;
  therapyPlan?: string;
}

export interface IConsultationCoachSupervisorResponse {
  consultationId: string;
  userName: string;
  coach_supervisor?: string;
  coachSupervisor?: string;
}

export interface IConsultationTalesTherapistResponse {
  consultationId: string;
  userName: string;
  tales_therapist?: string;
  talesTherapist?: string;
}

export interface IConsultationTranscriptionResponse {
  consultationId: string;
  userName: string;
  transcription?: string;
}

export const consultationResultsApi = createApi({
  reducerPath: 'consultationResultsApi',
  baseQuery: baseQueryV2,
  endpoints: (build) => ({
    getConsultationConclusion: build.query<IConsultationConclusionResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/conclusion`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationAbstract: build.query<IConsultationAbstractResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/abstract`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationHomework: build.query<IConsultationHomeworkResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/homework`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationMetaphor: build.query<IConsultationMetaphorResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/metaphor`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationMacTechnique: build.query<IConsultationMacTechniqueResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/mac_technique`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationTherapyPlan: build.query<IConsultationTherapyPlanResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/therapy_plan`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationCoachSupervisor: build.query<IConsultationCoachSupervisorResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/coach_supervisor`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationTalesTherapist: build.query<IConsultationTalesTherapistResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/tales_therapist`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
    getConsultationTranscription: build.query<IConsultationTranscriptionResponse, string>({
      query: (consultationId) => ({
        url: `/consultation-service/${consultationId}/results/transcription`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }),
    }),
  }),
});

export const {
  useGetConsultationConclusionQuery,
  useLazyGetConsultationAbstractQuery,
  useGetConsultationAbstractQuery,
  useGetConsultationHomeworkQuery,
  useGetConsultationMetaphorQuery,
  useGetConsultationMacTechniqueQuery,
  useGetConsultationTherapyPlanQuery,
  useGetConsultationCoachSupervisorQuery,
  useGetConsultationTalesTherapistQuery,
  useGetConsultationTranscriptionQuery,
} = consultationResultsApi;
